export default __webpack_public_path__ + "static/examp6-e01c9aee40571ec2a7aa70adb9b8e03c.gif";